/* eslint-disable import/first */
import React from "react"

export default function Sterilization() {
  return (
    <symbol id="svg-select-sterilization" viewBox="0 0 32 32">
      <path
        d="m26.3 6h-20.6c-1.8 0-3.2 1.4-3.2 3.1v13.8c0 1.7 1.4 3.2 3.2 3.2h20.7c1.7 0 3.2-1.4 3.2-3.2v-13.8c-.1-1.7-1.5-3.1-3.3-3.1zm2.9 16.9c0 1.6-1.3 2.9-2.9 2.9h-20.6c-1.6 0-2.9-1.3-2.9-2.9v-13.8c0-1.6 1.3-2.9 2.9-2.9h20.7c1.6 0 2.9 1.3 2.9 2.9v13.8z"
        fill="currentColor"
        stroke="currentColor"
        strokeMiterlimit="10"
        strokeWidth=".9"
      />
      <path
        d="m6.8 9.1h-1.9c-.6 0-1.1.5-1.1 1.1s.5 1.1 1.1 1.1h1.9c.6 0 1.1-.5 1.1-1.1s-.5-1.1-1.1-1.1zm0 1.8h-1.9c-.4 0-.8-.3-.8-.8 0-.4.3-.8.8-.8h1.9c.4 0 .8.3.8.8s-.4.8-.8.8z"
        fill="currentColor"
        stroke="currentColor"
        strokeMiterlimit="10"
        strokeWidth=".9"
      />
      <path
        d="m4.3 12.3c0-.1 0-.1.1-.1h.3c.1 0 .1 0 .1.1v.3c0 .1 0 .1-.1.1h-.3c-.1 0-.1 0-.1-.1z"
        fill="currentColor"
        stroke="currentColor"
        strokeMiterlimit="10"
        strokeWidth=".9"
      />
      <path
        d="m5.6 12.3c0-.1 0-.1.1-.1h.3c.1 0 .1 0 .1.1v.3c0 .1 0 .1-.1.1h-.3c-.1 0-.1 0-.1-.1z"
        fill="currentColor"
        stroke="currentColor"
        strokeMiterlimit="10"
        strokeWidth=".9"
      />
      <path
        d="m6.9 12.3c0-.1 0-.1.1-.1h.3c.1 0 .1 0 .1.1v.3c0 .1 0 .1-.1.1h-.3c-.1 0-.1 0-.1-.1z"
        fill="currentColor"
        stroke="currentColor"
        strokeMiterlimit="10"
        strokeWidth=".9"
      />
      <path
        d="m4.3 13.6c0-.1 0-.1.1-.1h.3c.1 0 .1 0 .1.1v.3c0 .1 0 .1-.1.1h-.3c-.1 0-.1 0-.1-.1z"
        fill="currentColor"
        stroke="currentColor"
        strokeMiterlimit="10"
        strokeWidth=".9"
      />
      <path
        d="m5.6 13.6c0-.1 0-.1.1-.1h.3c.1 0 .1 0 .1.1v.3s-.1.1-.1.1h-.3c-.1 0-.1 0-.1-.1z"
        fill="currentColor"
        stroke="currentColor"
        strokeMiterlimit="10"
        strokeWidth=".9"
      />
      <path
        d="m6.9 13.6c0-.1 0-.1.1-.1h.3c.1 0 .1 0 .1.1v.3c0 .1 0 .1-.1.1h-.3c-.1 0-.1 0-.1-.1z"
        fill="currentColor"
        stroke="currentColor"
        strokeMiterlimit="10"
        strokeWidth=".9"
      />
      <path
        d="m4.3 15c0-.1 0-.1.1-.1h.3c.1 0 .1 0 .1.1v.3c0 .1 0 .1-.1.1h-.3c-.1 0-.1 0-.1-.1z"
        fill="currentColor"
        stroke="currentColor"
        strokeMiterlimit="10"
        strokeWidth=".9"
      />
      <path
        d="m5.6 15c0-.1 0-.1.1-.1h.3c.1 0 .1 0 .1.1v.3c0 .1 0 .1-.1.1h-.3c-.1 0-.1 0-.1-.1z"
        fill="currentColor"
        stroke="currentColor"
        strokeMiterlimit="10"
        strokeWidth=".9"
      />
      <path
        d="m6.9 15c0-.1 0-.1.1-.1h.3c.1 0 .1 0 .1.1v.3c0 .1 0 .1-.1.1h-.3c-.1 0-.1 0-.1-.1z"
        fill="currentColor"
        stroke="currentColor"
        strokeMiterlimit="10"
        strokeWidth=".9"
      />
      <path
        d="m25.2 7.9h-13.6c-1.5 0-2.7 1.2-2.7 2.7v10.7c0 1.5 1.2 2.7 2.7 2.7h13.6c1.5 0 2.7-1.2 2.7-2.7v-10.7c0-1.5-1.2-2.7-2.7-2.7zm2.4 13.3c0 1.3-1.1 2.4-2.4 2.4h-13.6c-1.3 0-2.4-1.1-2.4-2.4v-10.6c0-1.3 1.1-2.4 2.4-2.4h13.6c1.3 0 2.4 1.1 2.4 2.4z"
        fill="currentColor"
        stroke="currentColor"
        strokeMiterlimit="10"
        strokeWidth=".9"
      />
      <path
        d="m7.3 16.9h-2.9c-.2 0-.3-.1-.3-.3s.1-.3.3-.3h2.9c.2 0 .3.1.3.3s-.1.3-.3.3z"
        fill="currentColor"
        stroke="currentColor"
        strokeMiterlimit="10"
        strokeWidth=".9"
      />
      <path
        d="m12.7 13.3c-1.4 0-2.6 1.2-2.6 2.6s1.2 2.6 2.6 2.6 2.6-1.2 2.6-2.6-1.1-2.6-2.6-2.6zm0 4.9c-1.3 0-2.3-1-2.3-2.3s1-2.3 2.3-2.3 2.3 1 2.3 2.3-1 2.3-2.3 2.3z"
        fill="currentColor"
        stroke="currentColor"
        strokeMiterlimit="10"
        strokeWidth=".9"
      />
    </symbol>
  )
}
